export default "__VITE_ASSET__3f6fbf2d__"